export default "__VITE_ASSET__CzJW1GIZ__"